import { ChevronRight } from '@ifood/pomodoro-icons';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React from 'react';
import { LayoutProps, SpaceProps } from 'styled-system';

import {
  PostCardContent,
  PostCardDetails,
  PostCardLink,
  PostCardThumbnail,
  PostCardTitle,
  PostCardWrapperLink,
} from './styles';

export type PropTypes = {
  className?: string;
  thumbnail: string;
  title: React.ReactNode;
  path?: string;
  linkText?: string;
  external?: boolean;
} & SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

const PostCard = ({ thumbnail, path = '#', linkText, title, external = false, ...props }: PropTypes): JSX.Element => (
  <PostCardWrapperLink href={path} target={external ? '_blank' : undefined}>
    <PostCardContent {...props} flexDirection="column">
      <PostCardThumbnail style={{ backgroundImage: `url('${thumbnail}')` }} />
      <PostCardDetails flexDirection="column" justifyContent="space-between">
        <PostCardTitle>{title}</PostCardTitle>
        <PostCardLink>
          {linkText || <FormattedMessage id="ui.post-card.read-article" />}
          <ChevronRight width={32} height={32} />
        </PostCardLink>
      </PostCardDetails>
    </PostCardContent>
  </PostCardWrapperLink>
);

export default PostCard;
